// extracted by mini-css-extract-plugin
export default {"content":"ContactForm_content__23MyE","title":"ContactForm_title__s0W0B","form":"ContactForm_form__Aw+1W"};